module.exports = __webpack_public_path__ + "static/leaf2-01-025e115905d5be059e58b4d4e279844b.png";